import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class Report extends RestApiModel {
  static getResourceEndpoint() {
    return '/Report';
  }
  static getReportTypes({ reportType, coverholder, binder, selectedOption, language }) {
    return api.get(this.getResourceEndpoint(), {
      params: {
        reportType,
        coverholder,
        binder,
        selectedOption,
        language
      }
    });
  }
}

export default Report;
